const doc = [({"da":({"models":({"feedback_survey":({"new":"Ny", "started":"Startet"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;